import React from 'react'
import {Cashback as CashbackType, SplitBookingBundle} from '@findhotel/sapi'
import {SplitBookingOfferInfo} from 'components/Offer/types'

import {OfferPrimaryLayoutVariant} from '@vio/core/src/offer/types/OfferLayout'
import {Cashback} from '@vio/shared/src/cashback/components/Cashback'
import {OfferLayout} from '@vio/shared/src/search/OfferLayout'

import {ProviderLogoComponent} from '../Shared/ProviderLogoComponent'
import {RoomLabelsComponent} from '../Shared/RoomLabelsComponent'
import {CtaComponent} from './CtaComponent'
import {PriceComponent} from './PriceComponent'
import {RoomSwitchRequiredTooltip} from './RoomSwitchRequiredTooltip/RoomSwitchRequiredTooltip'

interface SplitBookingProps {
  isLoading?: false
  variant: OfferPrimaryLayoutVariant
  hotelId: string
  splitBookingOffers: SplitBookingOfferInfo[]
  splitBookingBundle?: SplitBookingBundle & {
    cashback?: CashbackType
  }
  hasRoomLabels?: boolean
  isSplitBooking: boolean
  shouldShowTaxation?: boolean
  shouldShowTaxationAndNightly?: boolean
  showPriceIndication?: boolean
  offerVariant?: never
  hasInteraction?: false
  offer?: never
  anchorPrice?: number
  anchorPriceTotal?: number
  shouldShowCtaLockIcon?: never
  sourceComponent?: string
  offerPosition?: never
  hasWeb2AppPromo?: never
  showCashback?: boolean
  showProviderLogo?: boolean
  showCta?: boolean
}

export const SplitBookingPrimaryOffer: React.FC<SplitBookingProps> = ({
  anchorPrice,
  anchorPriceTotal,
  variant,
  hotelId,
  splitBookingOffers = [],
  isLoading = false,
  shouldShowTaxation = true,
  shouldShowTaxationAndNightly = false,
  hasRoomLabels = true,
  showCashback = false,
  splitBookingBundle,
  showProviderLogo,
  showCta = true
}) => {
  const cashbackValue = splitBookingBundle?.cashback?.value
  const cashbackType = splitBookingBundle?.cashback?.type

  return (
    <OfferLayout
      dataId="PrimarySplitBookingOffer"
      variant={variant}
      isLoading={isLoading}
      priceComponent={
        <PriceComponent
          isSplitBooking
          anchorPrice={anchorPrice}
          anchorPriceTotal={anchorPriceTotal}
          hotelId={hotelId}
          shouldShowTaxation={shouldShowTaxation}
          shouldShowTaxationAndNightly={shouldShowTaxationAndNightly}
          variant={variant}
        />
      }
      cashbackComponent={
        showCashback && <Cashback value={cashbackValue} type={cashbackType} />
      }
      providerLogoComponent={
        showProviderLogo ? (
          <ProviderLogoComponent
            hotelId={hotelId}
            isSplitBooking
            splitBookingOffers={splitBookingOffers}
            variant={variant}
          />
        ) : undefined
      }
      roomLabelsComponent={
        <>
          <RoomLabelsComponent
            isSplitBooking
            splitBookingOffers={splitBookingOffers}
            hasRoomLabels={hasRoomLabels}
            hotelId={hotelId}
          />
          <RoomSwitchRequiredTooltip />
        </>
      }
      ctaComponent={
        showCta && (
          <CtaComponent isSplitBooking hotelId={hotelId} variant={variant} />
        )
      }
    />
  )
}
